import {
	requests
}from '../../../api/agent'

export default {
	getExceptDaysForReOrg    : (params) => requests.get(`/calendar/getExceptDaysForReOrg`, params)
}